import { IValidationRule } from "@/types"

const taxBasedDeductionValidationRules: { [s: string]: IValidationRule } = {
    percentageIFRS: {
        required: true,
        type: "decimal",
        min: -100,
        max: 100,
    },
    percentageLocal: {
        required: true,
        type: "decimal",
        min: -100,
        max: 100,
    },
}

export default taxBasedDeductionValidationRules
